<template>
  <Modal
    v-model="showModal"
    class-name="vertical-center-modal"
    footer-hide>
    <Row type="flex" justify="start" align="middle">
      <Col :xs="24" :sm="12" :md="8" v-for="(media, idx) in socialMedia" :key="idx" class="padding-bt-20 text-center">
        <ShareNetwork
          :network="media.network"
          :title="title"
          :url="url">
          <Avatar :style="`background-color:${media.color}`" :icon="media.icon" :size="40"/>
          <p style="color:#515a6e">{{ media.name }}</p>
        </ShareNetwork>
      </Col>
      <Col :xs="24" :sm="12" :md="8" class="padding-bt-20 text-center">
        <div class="clickable" @click="copyUrl">
          <Avatar style="background-color:#95a5a6" icon="md-copy" :size="40"/>
          <p>Copy link</p>
        </div>
      </Col>
    </Row>
  </Modal>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    url: {
      type: String,
      default: '',
      required: true
    }
  },

  data () {
    return {
      showModal: false,
      socialMedia: [
        {
          network: 'facebook',
          name: 'Facebook',
          icon: 'logo-facebook',
          color: '#3b5998'
        },
        {
          network: 'twitter',
          name: 'Twitter',
          icon: 'logo-twitter',
          color: '#4099FF'
        },
        {
          network: 'linkedin',
          name: 'LinkedIn',
          icon: 'logo-linkedin',
          color: '#0077B5'
        }
      ]
    }
  },

  methods: {
    openModal () {
      this.showModal = true
    },

    copyUrl () {
      const el = document.createElement('textarea')
      el.value = this.url
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }

      this.$Message.success({
        background: true,
        content: 'Copied!'
      })
    }
  }
}
</script>

<style lang="scss">
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal{
    top: 0;
  }
}
</style>
